import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import axios from "axios";
import { ToasterService } from "../toaster.service";
import { SpinnerService } from "../spinner.service";
import { environment } from "src/environments/environment";
import { CordovaService } from "../cordova.service";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { AppState } from "../app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../session/session.service";
import { I18n } from "../i18n.service";
import { HomeUiService } from "../new-design/home-ui.service";
import { Platform } from "@ionic/angular";
import { IosASWebauthenticationSession } from '@ionic-native/ios-aswebauthenticationsession-api/ngx';
import mixpanel from "mixpanel-browser";
import { Observable } from 'rxjs'

interface SignInFormSSO {
  email: string;
  ssoUid: string;

  isSso: boolean;
  changePath: boolean;
  fromMobile: boolean;
  pathGroupId: number;
  pathId: number;
  ssoProvider: string;
}

const SSO_PROVIDER = 'ssoProvider'
const API_URL: string = environment.apiBaseUrl
const USER_INFO_URL='/sso/exchange_token'
const DUO_USER_INFO_URL='/sso/exchange_duo_token'
@Injectable({
  providedIn: "root",
})
export class SignInService {

  isMobile: any;
  signInFormSSO: SignInFormSSO;
  error: any;
  toast: ToasterService;
  spinner: SpinnerService;
  route: ActivatedRoute;
  router: Router;
  showAuthLoader = false;
  constructor(
    private appState: AppState,
    private sessionService: SessionService,
    private inAppBrowser: InAppBrowser,
    private i18n: I18n,
    private cordovaService: CordovaService,
    private homeUiService: HomeUiService,
    private platform: Platform,
    private http: HttpClient,
    private iosASWebAuthSession: IosASWebauthenticationSession
  ) {
    this.isMobile = this.appState.get("isMobile");
  }

  initServices(
    toasterService: ToasterService,
    spinnerService: SpinnerService,
    route: ActivatedRoute,
    router: Router,
   
  ) {
    this.toast = toasterService;
    this.spinner = spinnerService;
    this.route = route;
    this.router = router;
  }

  openKohlerMobileBrowser(url) {
    if (this.cordovaService.onCordova) {
      if (this.platform.is("ios")) {
        let callbackURLScheme = "com1st90";
        try {
          console.log("sessio started", url);
          this.iosASWebAuthSession
            .start(encodeURIComponent(callbackURLScheme), url)
            .then((response) => {
              this.showAuthLoader = true
               mixpanel.track('ASWebAuthentication Successfully started for ios kohler', {'callbackurl': response})
              console.log("Authentication successful url", response);
              this.getAccessCodeFromURLMobileKohler(response);
            })
            .catch((error) => {
              mixpanel.track('ASWebAuthentication is failed for kohler', {'callbackurl': error})
              console.error("Authentication failed", error);
              this.toast.error(this.i18n.t("Authentication failed"));
              this.showAuthLoader = false
            });
        } catch (error) {
          console.error("Error initializing ASWebAuthSession in kohler:", error);
          mixpanel.track('Error initializing ASWebAuthSession in kohler:',{error:error?.message? error?.message: error})
          this.toast.error(this.i18n.t("Error initializing ASWebAuthSession:"));
          this.showAuthLoader = false;
        }
      }
    }
  }

  openBrookfieldMobileBrowser(url) {
     if (this.cordovaService.onCordova) {
      if (this.platform.is("ios")) {
        let callbackURLScheme = "com1st90";
        try {
          console.log("sessio started", url);
          this.iosASWebAuthSession
            .start(encodeURIComponent(callbackURLScheme), url)
            .then((response) => {
              this.showAuthLoader = true
               mixpanel.track('ASWebAuthentication Successfully started for ios brookfield', {'callbackurl': response})
              console.log("Authentication successful url", response);
              this.getAccessCodeFromURLMobileBrookfield(response);
            })
            .catch((error) => {
              mixpanel.track('ASWebAuthentication is failed for brookfield', {'callbackurl': error})
              console.error("Authentication failed", error);
              this.toast.error(this.i18n.t("Authentication failed"));
              this.showAuthLoader = false
            });
        } catch (error) {
          console.error("Error initializing ASWebAuthSession in brookfield:", error);
          mixpanel.track('Error initializing ASWebAuthSession in brookfield:',{error:error?.message? error?.message: error})
          this.toast.error(this.i18n.t("Error initializing ASWebAuthSession:"));
          this.showAuthLoader = false;
        }
      }
    }
  }

  openADSMobileBrowser(url) {
     if (this.cordovaService.onCordova) {
      if (this.platform.is("ios")) {
        let callbackURLScheme = "com1st90";
        try {
          console.log("sessio started", url);
          this.iosASWebAuthSession
            .start(encodeURIComponent(callbackURLScheme), url)
            .then((response) => {
              this.showAuthLoader = true
               mixpanel.track('ASWebAuthentication Successfully started for ios ADS', {'callbackurl': response})
              console.log("Authentication successful url", response);
              this.getAccessCodeFromURLMobileADS(response);
            })
            .catch((error) => {
              mixpanel.track('ASWebAuthentication is failed for ADS', {'callbackurl': error})
              console.error("Authentication failed", error);
              this.toast.error(this.i18n.t("Authentication failed"));
              this.showAuthLoader = false
            });
        } catch (error) {
          console.error("Error initializing ASWebAuthSession in ADS:", error);
          mixpanel.track('Error initializing ASWebAuthSession in ADS:',{error:error?.message? error?.message: error})
          this.toast.error(this.i18n.t("Error initializing ASWebAuthSession:"));
          this.showAuthLoader = false;
        }
      }
    }
  }
  
  openGuardianMobileBrowser(url) {
     if (this.cordovaService.onCordova) {
      if (this.platform.is("ios")) {
        let callbackURLScheme = "com1st90";
        try {
          console.log("sessio started", url);
          this.iosASWebAuthSession
            .start(encodeURIComponent(callbackURLScheme), url)
            .then((response) => {
              this.showAuthLoader = true
               mixpanel.track('ASWebAuthentication Successfully started for ios guardian', {'callbackurl': response})
              console.log("Authentication successful url", response);
              this.getAccessCodeFromURLMobileGuardian(response);
            })
            .catch((error) => {
              mixpanel.track('ASWebAuthentication is failed for guardian', {'callbackurl': error})
              console.error("Authentication failed", error);
              this.toast.error(this.i18n.t("Authentication failed"));
              this.showAuthLoader = false
            });
        } catch (error) {
          console.error("Error initializing ASWebAuthSession in guardian:", error);
          mixpanel.track('Error initializing ASWebAuthSession in guardian:',{error:error?.message? error?.message: error})
          this.toast.error(this.i18n.t("Error initializing ASWebAuthSession:"));
          this.showAuthLoader = false;
        }
      }
    }
  }
  openExxonMobileBrowser(url) {
    if (this.cordovaService.onCordova) {
      if (this.platform.is("ios")) {
        let callbackURLScheme = "com1st90";
        try {
          console.log("sessio started", url);
          this.iosASWebAuthSession
            .start(encodeURIComponent(callbackURLScheme), url)
            .then((response) => {
              this.showAuthLoader = true
               mixpanel.track('ASWebAuthentication Successfully started', {'callbackurl': response})
              console.log("Authentication successful url", response);
              this.getAccessCodeFromURLMobileExxon(response);
            })
            .catch((error) => {
              mixpanel.track('ASWebAuthentication is failed', {'callbackurl': error})
              console.error("Authentication failed", error);
              this.toast.error(this.i18n.t("Authentication failed"));
              this.showAuthLoader = false
            });
        } catch (error) {
          console.error("Error initializing ASWebAuthSession:", error);
          this.toast.error(this.i18n.t("Error initializing ASWebAuthSession:"));
          this.showAuthLoader = false;
        }
      }
    }
  }
  openAppianMobileBrowser(url) {
    if (this.cordovaService.onCordova) {
      if (this.platform.is("ios")) {
        let callbackURLScheme = "com1st90";
        try {
          console.log("sessio started", url);
          this.iosASWebAuthSession
            .start(encodeURIComponent(callbackURLScheme), url)
            .then((response) => {
              this.showAuthLoader = true
              mixpanel.track('ASWebAuthentication Successfully started for ios Appian', { 'callbackurl': response })
              console.log("Authentication successful url", response);
              this.getAccessCodeFromURLMobileAppian(response);
            })
            .catch((error) => {
              mixpanel.track('ASWebAuthentication is failed for Appian', { 'callbackurl': error })
              console.error("Authentication failed", error);
              this.toast.error(this.i18n.t("Authentication failed"));
              this.showAuthLoader = false
            });
        } catch (error) {
          console.error("Error initializing ASWebAuthSession in Appian:", error);
          mixpanel.track('Error initializing ASWebAuthSession in Appian:', { error: error?.message ? error?.message : error })
          this.toast.error(this.i18n.t("Error initializing ASWebAuthSession:"));
          this.showAuthLoader = false;
        }
      }
    }
  }

  openLMMobileBrowser(url) {
    if (this.cordovaService.onCordova) {
      if (this.platform.is("ios")) {
        let callbackURLScheme = "com1st90";
        try {
          console.log("sessio started", url);
          this.iosASWebAuthSession
            .start(encodeURIComponent(callbackURLScheme), url)
            .then((response) => {
              this.showAuthLoader = true
              mixpanel.track('ASWebAuthentication Successfully started for ios lockheed Martin', { 'callbackurl': response })
              console.log("Authentication successful url", response);
              this.getAccessCodeFromURLMobileLM(response);
            })
            .catch((error) => {
              mixpanel.track('ASWebAuthentication is failed for lockheed Martin', { 'callbackurl': error })
              console.error("Authentication failed", error);
              this.toast.error(this.i18n.t("Authentication failed"));
              this.showAuthLoader = false
            });
        } catch (error) {
          console.error("Error initializing ASWebAuthSession in lockheed Martin:", error);
          mixpanel.track('Error initializing ASWebAuthSession in lockheed Martin:', { error: error?.message ? error?.message : error })
          this.toast.error(this.i18n.t("Error initializing ASWebAuthSession:"));
          this.showAuthLoader = false;
        }
      }
    }
  }

  openSSMobileBrowser(url) {
     if (this.cordovaService.onCordova) {
      if (this.platform.is("ios")) {
        let callbackURLScheme = "com1st90";
        try {
          console.log("sessio started", url);
          this.iosASWebAuthSession
            .start(encodeURIComponent(callbackURLScheme), url)
            .then((response) => {
              this.showAuthLoader = true
              mixpanel.track('ASWebAuthentication Successfully started for ios SingleStore', { 'callbackurl': response })
              console.log("Authentication successful url", response);
              this.getAccessCodeFromURLMobileSingleStore(response);
            })
            .catch((error) => {
              mixpanel.track('ASWebAuthentication is failed for SingleStore', { 'callbackurl': error })
              console.error("Authentication failed", error);
              this.toast.error(this.i18n.t("Authentication failed"));
              this.showAuthLoader = false
            });
        } catch (error) {
          console.error("Error initializing ASWebAuthSession in SingleStore:", error);
          mixpanel.track('Error initializing ASWebAuthSession in SingleStore:', { error: error?.message ? error?.message : error })
          this.toast.error(this.i18n.t("Error initializing ASWebAuthSession:"));
          this.showAuthLoader = false;
        }
      }
    }
  }
  openSAPBrowser(url: string) {
    if (this.cordovaService.onCordova) {
      var ref = this.inAppBrowser.create(url, "_blank", "location=yes");
      ref.on("loadstop").subscribe(async (event) => {
        this.showAuthLoader = true;
        if(localStorage.getItem(SSO_PROVIDER) === 'SAP'){
          this.getCodeAndStateFromUrl(event.url, ref);
        }else if(localStorage.getItem(SSO_PROVIDER) === 'DENONE'){
          this.getAccessCodeFromUrlDenone(event.url, ref);
        }else if(localStorage.getItem(SSO_PROVIDER) === 'OKTA'){
          this.getAccessCodeFromUrlOkta(event.url, ref);
        }else if(localStorage.getItem(SSO_PROVIDER) === 'EXXON'){
          console.log('EXXON event.url :', event.url);
          this.getAccessCodeFromUrlExxon(event.url, ref);
        }else if(localStorage.getItem(SSO_PROVIDER) === 'LULULEMON'){
          console.log('LULULEMON event.url :', event.url);
          this.getAccessCodeFromUrlLululemon(event.url, ref);
        }
        else if(localStorage.getItem(SSO_PROVIDER) === 'KOHLER'){
          mixpanel.track("kohler login URL", {url: event.url})
          console.log('KOHLER event.url :', event.url);
          this.getAccessCodeFromUrlKohler(event.url, ref);
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'APPIAN') {
          mixpanel.track("APPIAN login URL", {url: event.url})
          this.getCodeAndStateFromUrl(event.url, ref);
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'BROOKFIELD RESIDENTIAL') {
          mixpanel.track("BROOKFIELD RESIDENTIAL login URL", {url: event.url})
          this.getCodeAndStateFromUrl(event.url,ref);
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'ADS') {
          mixpanel.track("ADS login URL", {url: event.url})
          this.getCodeAndStateFromUrl(event.url,ref);
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'GUARDIAN INSURANCE') {
          mixpanel.track("GUARDIAN INSURANCE login URL", {url: event.url})
          this.getCodeAndStateFromUrl(event.url,ref);
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'LOCKHEED MARTIN') {
          mixpanel.track("LM login URL", {url: event.url})
          this.getCodeAndStateFromUrl(event.url, ref);
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'SingleStore') {
          mixpanel.track("SingleStore login URL", {url: event.url})
          this.getCodeAndStateFromUrl(event.url, ref);
        }
      });
      ref.on('exit').subscribe(() => {
        this.showAuthLoader = false;
        mixpanel.track("User closed the SSO window manually.", { SSO_PROVIDER: localStorage.getItem(SSO_PROVIDER) })
       // this.router.navigate(['/login']);
      });
      ref.on("loaderror").subscribe(async (event) => {
        this.showAuthLoader = false;
        this.toast.error(this.i18n.t(event.message));
        mixpanel.track("Error in authentication",{event: event?.message } )
        this.getCodeAndStateFromUrl(event.url, ref);
      });
    }
  }
  getAccessCodeFromURLMobileBrookfield(callBackurl) {
      const url = new URL(callBackurl);
      console.log('callBackurl :', url);
      let code, state, expired, client;
      const loading = false;
      const valid = true;
      if (callBackurl.includes("code=") && callBackurl.includes("state=")) {
        let pamasString = callBackurl.split("?")[1];
        let codeString = pamasString.split("&")[0];
        let stateString = pamasString.split("&")[1];
        code = codeString.split("=")[1];
        state = stateString.split("=")[0];
        mixpanel.track('Fetched code and state from brookfield residential auth URL', { urlString: callBackurl, code: code, state: state, platform: this.platform.is('android') ? 'android' : 'ios' })
        localStorage.setItem(environment.BROOKFIELD_CODE, code);
        localStorage.setItem('brookfield_state', state);

      }
      if (code && state) {
        mixpanel.track('Access token from brookfield residential in mobile', { code: code, stateSting: state })
        localStorage.setItem(environment.BROOKFIELD_CODE, code);
        if (this.platform.is('android')) {
          this.authenticateSSOTokenForLogin(loading, expired, client, valid)
        }
        else if (this.platform.is('ios')) {
          window.location.reload();
        }
      }
      else {
        this.toast.error(this.i18n.t("access_token not found"));
        mixpanel.track('access_token not found for brookfield residential mobile')
        this.showAuthLoader = false;
    }
  }
  getAccessCodeFromURLMobileADS(callBackurl) {
      const url = new URL(callBackurl);
      console.log('callBackurl :', url);
      let code, state, expired, client;
      const loading = false;
      const valid = true;
      if (callBackurl.includes("code=") && callBackurl.includes("state=")) {
        let pamasString = callBackurl.split("?")[1];
        let codeString = pamasString.split("&")[0];
        let stateString = pamasString.split("&")[1];
        code = codeString.split("=")[1];
        state = stateString.split("=")[0];
        mixpanel.track('Fetched code and state from ADS auth URL', { urlString: callBackurl, code: code, state: state, platform: this.platform.is('android') ? 'android' : 'ios' })
        localStorage.setItem(environment.ADS_CODE, code);
        localStorage.setItem('ads_state', state);

      }
      if (code && state) {
        mixpanel.track('Access token from ADS in mobile', { code: code, stateSting: state })
        localStorage.setItem(environment.ADS_CODE, code);
        if (this.platform.is('android')) {
          this.authenticateSSOTokenForLogin(loading, expired, client, valid)
        }
        else if (this.platform.is('ios')) {
          window.location.reload();
        }
      }
      else {
        this.toast.error(this.i18n.t("access_token not found"));
        mixpanel.track('access_token not found for ADS mobile')
        this.showAuthLoader = false;
    }
  }
  getAccessCodeFromURLMobileGuardian(callBackurl) {
      const url = new URL(callBackurl);
      console.log('callBackurl :', url);
      let code, state, expired, client;
      const loading = false;
      const valid = true;
      if (callBackurl.includes("code=") && callBackurl.includes("state=")) {
        let pamasString = callBackurl.split("?")[1];
        let codeString = pamasString.split("&")[0];
        let stateString = pamasString.split("&")[1];
        code = codeString.split("=")[1];
        state = stateString.split("=")[0];
        mixpanel.track('Fetched code and state from guardian insurance auth URL', { urlString: callBackurl, code: code, state: state, platform: this.platform.is('android') ? 'android' : 'ios' })
        localStorage.setItem(environment.GUARDIAN_CODE, code);
        localStorage.setItem('guardian_state', state);

      }
      if (code && state) {
        mixpanel.track('Access token from guardian insurance in mobile', { code: code, stateSting: state })
        localStorage.setItem(environment.GUARDIAN_CODE, code);
        if (this.platform.is('android')) {
          this.authenticateSSOTokenForLogin(loading, expired, client, valid)
        }
        else if (this.platform.is('ios')) {
          window.location.reload();
        }
      }
      else {
        this.toast.error(this.i18n.t("access_token not found"));
        mixpanel.track('access_token not found for guardian insurance mobile')
        this.showAuthLoader = false;
      }
    
    // else {
    //   const url = new URL(callBackurl);
    //   console.log('callBackurl :', url);
    //   let accessToken;
    //   //const accessToken = url?.searchParams.get("access_token");
    //   mixpanel.track("guardian url for mobile", { url: url, platform: this.platform.is('android') })
    //   if (callBackurl.includes("access_token=")) {
    //     let splittedValue = callBackurl?.split("=");
    //     let unfilteredToken = splittedValue[1]?.split("&");
    //     accessToken = Array.isArray(unfilteredToken)
    //       ? unfilteredToken[0]
    //       : null;
    //   }
    //   if (accessToken) {
    //     mixpanel.track('Access token from guardian in mobile', { accessToken: accessToken })
    //     localStorage.setItem(environment.GUARDIAN_CODE, accessToken);
    //      if (this.platform.is('android')) {
        //   this.authenticateSSOTokenForLogin(loading, expired, client, valid)
        // }
        // else if (this.platform.is('ios')) {
        //   window.location.reload();
        // }
    //   }
    //   else {
    //     this.toast.error(this.i18n.t("access_token not found"));
    //     mixpanel.track('access_token not found for guardian mobile')
    //     this.showAuthLoader = false;
    //   }
    // }
  }

  getAccessCodeFromURLMobileKohler(callBackurl) {
    const url = new URL(callBackurl);
    console.log('callBackurl :', url);
    let accessToken;
    //const accessToken = url?.searchParams.get("access_token");
    mixpanel.track("kohler url for mobile",{url:url, platform: this.platform.is('android')})
    if (callBackurl.includes("access_token=")) {
      let splittedValue = callBackurl?.split("=");
      let unfilteredToken = splittedValue[1]?.split("&");
       accessToken = Array.isArray(unfilteredToken)
        ? unfilteredToken[0]
        : null;
    }
    if (accessToken) {
      mixpanel.track('Access token from kohler in mobile',{accessToken: accessToken})
      localStorage.setItem(environment.KOHLER_CODE, accessToken);
       window.location.reload();
    }
    else {
      this.toast.error(this.i18n.t("access_token not found"));
      mixpanel.track('access_token not found for kohler mobile')
      this.showAuthLoader = false;
    }
  }

  getAccessCodeFromURLAndroidMobileKohler(callBackurl) {
    const url = new URL(callBackurl);
    console.log('callBackurl :', url);
    let accessToken, expired, client;
    const loading = false;
    const valid = true;
    //const accessToken = url?.searchParams.get("access_token");
    mixpanel.track("kohler url for mobile", { url: url, platform: this.platform.is('android') })
    if (callBackurl.includes("access_token=")) {
      let splittedValue = callBackurl?.split("=");
      let unfilteredToken = splittedValue[1]?.split("&");
      accessToken = Array.isArray(unfilteredToken)
        ? unfilteredToken[0]
        : null;
    }
    if (accessToken) {
      mixpanel.track('Access token from kohler in mobile', { accessToken: accessToken })
      localStorage.setItem(environment.KOHLER_CODE, accessToken);
      this.authenticateSSOTokenForLogin(loading, expired, client, valid)
    }
    else {
      this.toast.error(this.i18n.t("access_token not found"));
      mixpanel.track('access_token not found for kohler mobile')
      this.showAuthLoader = false;
    }
  }
  
  getAccessCodeFromURLMobileExxon(callBackurl) {
    const url = new URL(callBackurl);
    console.log('callBackurl :', url);
    let accessToken;
    //const accessToken = url?.searchParams.get("access_token");
    if (callBackurl.includes("access_token=")) {
      let splittedValue = callBackurl?.split("=");
      let unfilteredToken = splittedValue[1]?.split("&");
       accessToken = Array.isArray(unfilteredToken)
        ? unfilteredToken[0]
        : null;
    }
    if (accessToken) {
      localStorage.setItem(environment.EXXON_CODE, accessToken);
       window.location.reload();
    }
    else {
      this.toast.error(this.i18n.t("access_token not found"));
      this.showAuthLoader = false;
    }
  }

  getAccessCodeFromURLMobileAppian(callBackurl) {
    const url = new URL(callBackurl);
    console.log('callBackurl :', url);
    let code, state, expired, client;
      const loading = false;
      const valid = true;
    //const accessToken = url?.searchParams.get("access_token");
    if (callBackurl.includes("code=") && callBackurl.includes("state=")) {
      let pamasString = callBackurl.split("?")[1];
      let codeString = pamasString.split("&")[0];
      let stateString = pamasString.split("&")[1];
       code = codeString.split("=")[1];
       state = stateString.split("=")[0];
      mixpanel.track('Fetched code and state from appian auth URL', { urlString: callBackurl, code: code, state: state, platform: this.platform.is('android') ? 'android' : 'ios' })
      localStorage.setItem(environment.APPIAN_CODE, code);
      localStorage.setItem('appian_state', state);

    }
    if (code && state) {
      mixpanel.track('Access token from appian in mobile',{code: code, stateSting: state})
      localStorage.setItem(environment.APPIAN_CODE, code);
      if(this.platform.is('android')){
        this.authenticateSSOTokenForLogin(loading,expired, client, valid)
      }
      else if(this.platform.is('ios')){
        window.location.reload();
      }
    }
    else {
      this.toast.error(this.i18n.t("access_token not found"));
      mixpanel.track('access_token not found for appian mobile')
      this.showAuthLoader = false;
    }
    }
    getAccessCodeFromURLMobileLM(callBackurl) {
    const url = new URL(callBackurl);
    console.log('callBackurl :', url);
    let code, state;
    //const accessToken = url?.searchParams.get("access_token");
    if (callBackurl.includes("code=") && callBackurl.includes("state=")) {
      let pamasString = callBackurl.split("?")[1];
      let codeString = pamasString.split("&")[0];
      let stateString = pamasString.split("&")[1];
       code = codeString.split("=")[1];
       state = stateString.split("=")[0];
      mixpanel.track('Fetched code and state from LM auth URL', { urlString: callBackurl, code: code, state: state })
      localStorage.setItem(environment.LMCODE, code);
      localStorage.setItem('lockheedmartin_state', state);

    }
    if (code && state) {
      mixpanel.track('Access token from LM in mobile',{code: code, stateSting: state})
      localStorage.setItem(environment.LMCODE, code);
       window.location.reload();
    }
    else {
      this.toast.error(this.i18n.t("access_token not found"));
      mixpanel.track('access_token not found for LM mobile')
      this.showAuthLoader = false;
    }
    }
  
  getAccessCodeFromURLMobileSingleStore(callBackurl) {
     const url = new URL(callBackurl);
    console.log('callBackurl :', url);
    let code, state, expired, client;
      const loading = false;
      const valid = true;
    //const accessToken = url?.searchParams.get("access_token");
    if (callBackurl.includes("code=") && callBackurl.includes("state=")) {
      let pamasString = callBackurl.split("?")[1];
      let codeString = pamasString.split("&")[0];
      let stateString = pamasString.split("&")[1];
       code = codeString.split("=")[1];
       state = stateString.split("=")[0];
      mixpanel.track('Fetched code and state from singlestore auth URL', { urlString: callBackurl, code: code, state: state, platform: this.platform.is('android') ? 'android' : 'ios' })
      localStorage.setItem(environment.SINGLESTORE_CODE, code);
      localStorage.setItem('singlestore_state', state);

    }
    if (code && state) {
      mixpanel.track('Access token from singlestore in mobile',{code: code, stateSting: state})
      localStorage.setItem(environment.SINGLESTORE_CODE, code);
      if(this.platform.is('android')){
        this.authenticateSSOTokenForLogin(loading,expired, client, valid)
      }
      else if(this.platform.is('ios')){
        window.location.reload();
      }
    }
    else {
      this.toast.error(this.i18n.t("access_token not found"));
      mixpanel.track('access_token not found for appian mobile')
      this.showAuthLoader = false;
    }
  }
    getAccessCodeFromURLAndroidMobileLM(callBackurl) {
    const url = new URL(callBackurl);
    console.log('callBackurl :', url);
      let code, state, expired, client;
      const loading = false;
      const valid = true;
    //const accessToken = url?.searchParams.get("access_token");
    if (callBackurl.includes("code=") && callBackurl.includes("state=")) {
      let pamasString = callBackurl.split("?")[1];
      let codeString = pamasString.split("&")[0];
      let stateString = pamasString.split("&")[1];
       code = codeString.split("=")[1];
       state = stateString.split("=")[0];
      mixpanel.track('Fetched code and state from LM auth URL', { urlString: callBackurl, code: code, state: state })
      localStorage.setItem(environment.LMCODE, code);
      localStorage.setItem('lockheedmartin_state', state);

    }
      if (code && state) {
        mixpanel.track('Access token from LM in mobile', { code: code, stateSting: state })
        localStorage.setItem(environment.LMCODE, code);
        this.authenticateSSOTokenForLogin(loading,expired, client, valid)
      }
    else {
      this.toast.error(this.i18n.t("access_token not found"));
      mixpanel.track('access_token not found for LM mobile')
      this.showAuthLoader = false;
    }
    }
  
  // fetch code and state from redirect url
  getParamsFromURL(
    loading: boolean,
    expired: boolean,
    client: any,
    valid: boolean
  ) {
    this.route.queryParams.subscribe(async (params) => {
      mixpanel.track('Params fetch from auth url', {params:params?JSON.stringify(params):params,url:this.router.url})
      let code = params?.code;
      let state = params?.state;
      let splittedValue = this.router.url?.split('=')
     console.log("query params method is called")
      let unfilteredToken = splittedValue[1]?.split('&')
      let accessToken = Array.isArray(unfilteredToken) ? unfilteredToken[0] : null;
      mixpanel.track("fetched code and state from url", {code:code, state:state, ssoProvider: localStorage.getItem(SSO_PROVIDER), accessToken:accessToken})
      if (code && state ||(localStorage.getItem(SSO_PROVIDER) === 'SAP' || localStorage.getItem(SSO_PROVIDER) === 'APPIAN' || localStorage.getItem(SSO_PROVIDER) === 'LOCKHEED MARTIN'|| localStorage.getItem(SSO_PROVIDER) === 'SingleStore' || localStorage.getItem(SSO_PROVIDER) === 'ADS')){
        var userInfo
        if (localStorage.getItem(SSO_PROVIDER) === 'SAP') {
          var userInfo = await this.getUserTokenSAP(code);
          this.signInFormSSO = {
            email: userInfo.data?.mail,
            ssoUid: userInfo.data?.uid,
            isSso: true,
            changePath: null,
            fromMobile: null,
            pathGroupId: 0,
            pathId: 0,
            ssoProvider: localStorage.getItem(SSO_PROVIDER) ? localStorage.getItem(SSO_PROVIDER) : 'undefined',
          };
          this.loginWithSSO(
            this.signInFormSSO,
            loading,
            expired,
            client,
            valid
          );
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'LOCKHEED MARTIN') {
          if (code && state) {
            this.showAuthLoader = true;
            var userInfo = await this.getLMUserInfoViaApi(code);
            mixpanel.track("Fetch params from LM auth URL params object", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          else {
            let params: URLSearchParams;

            if (window.location.hash) {
              // Fragment (#code=xxx&state=yyy)
              params = new URLSearchParams(window.location.hash?.substring(1));
            }
            else if (window.location.search) {
              // Query string (?code=xxx&state=yyy)
              params = new URLSearchParams(window.location.search);
            } else {
              return null;
            }
            code = params?.get('code')
            state = params?.get('state')
            this.showAuthLoader = true;
            var userInfo = await this.getLMUserInfoViaApi(code);
            mixpanel.track("Fetch params via extracting from LM auth URL incase of type is fragment", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          
          if (userInfo) {
            mixpanel.track("Fetch params from LM auth URL params object in if block", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
            this.signInFormSSO = {
              // email: userInfo?.data ? userInfo?.data?.mail : userInfo?.mail,
              // ssoUid: userInfo?.data ? (userInfo?.data?.uid ? userInfo?.data?.uid : userInfo?.data?.sub) : (userInfo?.uid ? userInfo?.uid : userInfo?.sub),
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER) ? localStorage.getItem(SSO_PROVIDER) : 'undefined',
            };
         
            this.loginWithSSO(
              this.signInFormSSO,
              loading,
              expired,
              client,
              valid
            );
          }
          else {
            this.showAuthLoader = false;
            mixpanel.track("user info object is null in else block",{userInfo:userInfo})
          }
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'APPIAN') {
          if (code && state) {
            this.showAuthLoader = true;
            var userInfo = await this.getAppianUserInfoViaApi(code);
            mixpanel.track("Fetch params from Appian auth URL params object", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          else {
            let params: URLSearchParams;

            if (window.location.hash) {
              params = new URLSearchParams(window.location.hash?.substring(1));
            }
            else if (window.location.search) {
              params = new URLSearchParams(window.location.search);
            } else {
              return null;
            }
            code = params?.get('code')
            state = params?.get('state')
            this.showAuthLoader = true;
            var userInfo = await this.getAppianUserInfoViaApi(code);
            mixpanel.track("Fetch params via extracting from Appian auth URL incase of type is fragment", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          
          if (userInfo) {
            mixpanel.track("Fetch params from Appian auth URL params object in if block", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
            this.signInFormSSO = {
              // email: userInfo?.data ? userInfo?.data?.mail : userInfo?.mail,
              // ssoUid: userInfo?.data ? (userInfo?.data?.uid ? userInfo?.data?.uid : userInfo?.data?.sub) : (userInfo?.uid ? userInfo?.uid : userInfo?.sub),
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER) ? localStorage.getItem(SSO_PROVIDER) : 'undefined',
            };
         
            this.loginWithSSO(
              this.signInFormSSO,
              loading,
              expired,
              client,
              valid
            );
          }
          else {
            this.showAuthLoader = false;
            mixpanel.track("user info object is null in else block",{userInfo:userInfo})
          }
        }
          else if (localStorage.getItem(SSO_PROVIDER) === 'BROOKFIELD RESIDENTIAL') {
          if (code && state) {
            this.showAuthLoader = true;
            var userInfo = await this.getBrookfieldUserInfoViaApi(code);
            mixpanel.track("Fetch params from Brookfield Residential auth URL params object", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          else {
            let params: URLSearchParams;

            if (window.location.hash) {
              params = new URLSearchParams(window.location.hash?.substring(1));
            }
            else if (window.location.search) {
              params = new URLSearchParams(window.location.search);
            } else {
              return null;
            }
            code = params?.get('code')
            state = params?.get('state')
            this.showAuthLoader = true;
            var userInfo = await this.getBrookfieldUserInfoViaApi(code);
            mixpanel.track("Fetch params via extracting from Brookfield Residential auth URL incase of type is fragment", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          if (userInfo) {
            mixpanel.track("Fetch params from Brookfield Residential auth URL params object in if block", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
            this.signInFormSSO = {
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER) ? localStorage.getItem(SSO_PROVIDER) : 'undefined',
            };
         
            this.loginWithSSO(
              this.signInFormSSO,
              loading,
              expired,
              client,
              valid
            );
          }
          else {
            this.showAuthLoader = false;
            mixpanel.track("user info object is null in else block",{userInfo:userInfo})
          }
        }
          else if (localStorage.getItem(SSO_PROVIDER) === 'ADS') {
          if (code && state) {
            this.showAuthLoader = true;
            var userInfo = await this.getADSUserInfoViaApi(code);
            mixpanel.track("Fetch params from ADS auth URL params object", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          else {
            let params: URLSearchParams;

            if (window.location.hash) {
              params = new URLSearchParams(window.location.hash?.substring(1));
            }
            else if (window.location.search) {
              params = new URLSearchParams(window.location.search);
            } else {
              return null;
            }
            code = params?.get('code')
            state = params?.get('state')
            this.showAuthLoader = true;
            var userInfo = await this.getADSUserInfoViaApi(code);
            mixpanel.track("Fetch params via extracting from ADS auth URL incase of type is fragment", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }

          if (userInfo) {
            mixpanel.track("Fetch params from ADS auth URL params object in if block", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
            this.signInFormSSO = {
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER) ? localStorage.getItem(SSO_PROVIDER) : 'undefined',
            };

            this.loginWithSSO(
              this.signInFormSSO,
              loading,
              expired,
              client,
              valid
            );
          }
          else {
            this.showAuthLoader = false;
            mixpanel.track("user info object is null in else block for ADS",{userInfo:userInfo})
          }
        }
          else if (localStorage.getItem(SSO_PROVIDER) === 'GUARDIAN INSURANCE') {
          if (code && state) {
            this.showAuthLoader = true;
            var userInfo = await this.getGuardianUserInfoViaApi(code);
            mixpanel.track("Fetch params from Guardian Insurance auth URL params object", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          else {
            let params: URLSearchParams;

            if (window.location.hash) {
              params = new URLSearchParams(window.location.hash?.substring(1));
            }
            else if (window.location.search) {
              params = new URLSearchParams(window.location.search);
            } else {
              return null;
            }
            code = params?.get('code')
            state = params?.get('state')
            this.showAuthLoader = true;
            var userInfo = await this.getGuardianUserInfoViaApi(code);
            mixpanel.track("Fetch params via extracting from Guardian Insurance auth URL incase of type is fragment", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          
          if (userInfo) {
            mixpanel.track("Fetch params from Guardian Insurance auth URL params object in if block", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
            this.signInFormSSO = {
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER) ? localStorage.getItem(SSO_PROVIDER) : 'undefined',
            };
         
            this.loginWithSSO(
              this.signInFormSSO,
              loading,
              expired,
              client,
              valid
            );
          }
          else {
            this.showAuthLoader = false;
            mixpanel.track("user info object is null in else block",{userInfo:userInfo})
          }
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'SingleStore') {
          if (code && state) {
            this.showAuthLoader = true;
            var userInfo = await this.getSSUserInfoViaApi(code);
            mixpanel.track("Fetch params from SingleStore auth URL params object", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          else {
            let params: URLSearchParams;

            if (window?.location?.hash) {
              params = new URLSearchParams(window.location.hash?.substring(1));
            }
            else if (window?.location?.search) {
              params = new URLSearchParams(window.location.search);
            } else {
              return null;
            }
            code = params?.get('code')
            state = params?.get('state')
            this.showAuthLoader = true;
            var userInfo = await this.getSSUserInfoViaApi(code);
            mixpanel.track("Fetch params via extracting from SingleStore auth URL incase of type is fragment", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
          }
          
          if (userInfo?.email || userInfo?.sub) {
            mixpanel.track("Fetch params from SingleStore auth URL params object in if block", { code: code, userInfo: userInfo ? JSON.stringify(userInfo) : userInfo })
            this.signInFormSSO = {
              // email: userInfo?.data ? userInfo?.data?.mail : userInfo?.mail,
              // ssoUid: userInfo?.data ? (userInfo?.data?.uid ? userInfo?.data?.uid : userInfo?.data?.sub) : (userInfo?.uid ? userInfo?.uid : userInfo?.sub),
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER) ? localStorage.getItem(SSO_PROVIDER) : 'undefined',
            };
         
            this.loginWithSSO(
              this.signInFormSSO,
              loading,
              expired,
              client,
              valid
            );
          }
          else {
            this.showAuthLoader = false;
            this.toast.error(this.i18n.t('Failed to fetch user information due to server error'))
            mixpanel.track("user info object is null/incorrect in else block", { userInfo: userInfo })
          }
        }
      }else if(accessToken){
        console.log('accessToken :', accessToken);
        let valueToken = splittedValue[2]?.split('&')
        let token = valueToken[0]?.split('&')
        mixpanel.track("fetched token from url",{token:token})
        if (localStorage.getItem(SSO_PROVIDER) === 'OKTA') {
          // this.showAuthLoader = true;
          var userInfo = await this.getUserTokenOkta(token[0]);
          this.signInFormSSO = {
            email: userInfo.data?.email,
            ssoUid: userInfo.data?.sub,
            isSso: true,
            changePath: null,
            fromMobile: null,
            pathGroupId: 0,
            pathId: 0,
            ssoProvider: environment.OKTA,
          };
          this.loginWithSSO(
            this.signInFormSSO,
            loading,
            expired,
            client,
            valid
          );
        } else if (localStorage.getItem(SSO_PROVIDER) === 'EXXON') {
          // this.showAuthLoader = true;
           mixpanel.track('Fetch params from URL',{'SSO_provider':localStorage.getItem(SSO_PROVIDER)})
          var userInfo = await this.getUserInfoExxon(accessToken);
          console.log('EXXON userInfo & accessToken:', userInfo, accessToken);
          this.signInFormSSO = {
            email: userInfo.data?.email,
            ssoUid: userInfo.data?.sub,
            isSso: true,
            changePath: null,
            fromMobile: null,
            pathGroupId: 0,
            pathId: 0,
            ssoProvider: environment.EXXON,
          };
          this.loginWithSSO(
            this.signInFormSSO,
            loading,
            expired,
            client,
            valid
          );
        } else if (localStorage.getItem(SSO_PROVIDER) === 'LULULEMON') {
          var userInfo = await this.getUserInfoLululemon(accessToken);
          console.log('LULULEMON userInfo & accessToken :', userInfo, accessToken);
          this.signInFormSSO = {
            email: userInfo.data?.email,
            ssoUid: userInfo.data?.sub,
            isSso: true,
            changePath: null,
            fromMobile: null,
            pathGroupId: 0,
            pathId: 0,
            ssoProvider: environment.LULULEMON,
          };
          this.loginWithSSO(
            this.signInFormSSO,
            loading,
            expired,
            client,
            valid
          );
        }
        else if (localStorage.getItem(SSO_PROVIDER) === 'KOHLER') {
          var userInfo = await this.getUserInfoKohler(accessToken);
          console.log('Kohler userInfo & accessToken :',userInfo, accessToken,splittedValue,token);
        //  this.showAuthLoader = true;
          if (userInfo?.data) {
            this.signInFormSSO = {
              email: userInfo.data?.email,
              ssoUid: userInfo.data?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: environment.KOHLER,
            };
            mixpanel.track("Kohler user Info and access Token details", { userinfo: JSON.stringify(userInfo?.data), accessTokenLength: accessToken?.length, accessToken: accessToken })
            this.loginWithSSO(
              this.signInFormSSO,
              loading,
              expired,
              client,
              valid
            );
          }
            
          else {
           // this.showAuthLoader = false
              mixpanel.track("Issue in fetching Kohler user details via token", { userinfo: userInfo?.data?JSON.stringify(userInfo?.data):userInfo?.data, status: userInfo?.status })
            }
        }
        else {
          console.log('client not found & accessToken :', accessToken);
        }
          
        
        
      
      }
    });
  }

  async getUserInfoSAP(accessToken: string) {
    mixpanel.track("Access token for SAP is stored", { accessToken :accessToken})
    let config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    let body = {};

    try {
      return await axios.post(environment.GET_USER_INFO_SAP, body, config);
    } catch (error) {
      this.spinner.off();
      this.showAuthLoader = false;
    }
  }

    async getUserInfoLM(accessToken: string) {
    mixpanel.track("Access token for LM is stored", { accessToken :accessToken})
    let config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    let body = {};

    try {
      return await axios.post(environment.GET_USERINFO_LMCO, body, config);
    } catch (error) {
      this.spinner.off();
      mixpanel.track("Error while fetching userInfo for LM via token",{error: error})
      this.showAuthLoader = false;
    }
  }
  async getUserTokenSAP(code: string) {
    let userInfoResponse = null;
    let username = environment.userSSOSAP;
    let password = environment.secretSSOSAP;
    let body = new URLSearchParams();
             body.set('grant_type', `authorization_code`);
             body.set('redirect_uri', environment.SSO_REDIRECT_URL);
             body.set('code', code);
             body.set('client_id',  environment.clientIdSAP);

    const encodedToken = btoa(`${username}:${password}`);

    let config = {
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Basic " + encodedToken,
      },
      params: {
      },
    };

    try {
      const response = await axios.post(
        environment.GET_TOKEN_SAP,
        body.toString(),
        config
      );
      let token = response.data?.access_token;
      userInfoResponse = await this.getUserInfoSAP(token);
    } catch (error) {
      this.spinner.off();
      this.showAuthLoader = false;
      
    }
    return userInfoResponse;
  }

  async getUserTokenOkta(accessToken: string){
    mixpanel.track("Access token for Okta is stored", { accessToken :accessToken})
    let response = null
    let config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      response = await axios.get(environment.GET_USER_INFO_OKTA, config);
      return response;
    } catch (error) {
      this.spinner.off();
      this.showAuthLoader = false;
    }
  }

  async getUserInfoDenone(accessToken: string) {
    mixpanel.track("Access token for Denone is stored", { accessToken :accessToken})
    let response = null
    let config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    let body = {};

    try {
      response = await axios.post(environment.GET_USER_INFO_DENONE, body, config);
      return response;
    } catch (error) {
      this.spinner.off();
      this.showAuthLoader = false;
    }
  }

  async getUserInfoExxon(accessToken: string) {
    console.log('getUserInfoExxon accessToken :', accessToken);
    mixpanel.track("Access token for EXXONMOBIL is stored", { accessToken :accessToken})
    let response = null
    let config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    let body = {};

    try {
      response = await axios.post(environment.GET_USER_INFO_EXXON, body, config);
      console.log('GET_USER_INFO_EXXON response :', response);
      return response;
    } catch (error) {
      this.showAuthLoader = false;
      console.log('GET_USER_INFO_EXXON error :', error);
      this.spinner.off();
    }
  }

  async getUserInfoLululemon(accessToken: string) {
    mixpanel.track("Access token for Lululemon is stored", { accessToken :accessToken})
    console.log('getUserInfoLululemon accessToken :', accessToken);
    let response = null
    let config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    let body = {};

    try {
      response = await axios.post(environment.GET_USER_INFO_LULULEMON, body, config);
      console.log('GET_USER_INFO_EXXON response :', response);
      return response;
    } catch (error) {
      console.log('GET_USER_INFO_EXXON error :', error);
      this.toast.error(error)
      this.showAuthLoader = false;
      this.spinner.off();
    }
  }
 async getUserInfoKohler(accessToken: string) {
    mixpanel.track("Access token for Kohler is stored", { accessToken :accessToken,accessTokenLength: accessToken?.length})
    console.log('getUserInfoKohler accessToken :', accessToken);
    let response = null
    let config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    let body = {};

    try {
      response = await axios.post(environment.GET_USER_INFO_KOHLER, body, config);
      console.log('GET_USER_INFO_Kohler response :', response);
      return response;
    } catch (error) {
      console.log('GET_USER_INFO_Kohler error :', error);
      const errorData = {
        message: error?.message,
        name: error?.name,
        stack: error?.stack,
        code: error?.code,
        innerError: error?.innerError,
        responseStatus: error?.response?.status,
        statusText: error?.response?.statusText,
        responseData: error?.response?.data,
        requestUrl: error?.config?.url,
        requestMethod: error?.config?.method,
      };

      mixpanel.track('GetUserInfoKohler error response in detailed format', {
        error: errorData?JSON.stringify(errorData):errorData,
      });
      this.toast.error(error)
      this.showAuthLoader = false;
      this.spinner.off();
    }
  }
 public fetchLMUserInfo(data): Observable<any>{
     const headers = new HttpHeaders();
     return this.http.post(API_URL + USER_INFO_URL,data,{headers})
 }
  
  public fetchDuoUserInfo(data): Observable<any>{
     const headers = new HttpHeaders();
     return this.http.post(API_URL + DUO_USER_INFO_URL,data,{headers})
 }
  async getAppianUserInfoViaApi(code: string) {
    try{
    // let userInfoResponse = null;
      const input={
        provider: environment.APPIAN_SSO_PROVIDER,
        code: code,
        redirect_uri:(this.isMobile &&(this.platform.is('ios') || this.platform.is('android')))&& !this.platform.is('mobileweb')?environment.SSO_APPIAN_MOBILE_CALLBACK_URL:environment.SSO_REDIRECT_URL
      }
    mixpanel.track('input params for Appian Userinfo', { AppianInput: input })
      let res = await this.fetchDuoUserInfo(input).toPromise();
      console.log("Appian user response", res);
      const userInfoResponse = res?.data ? res?.data?.user : res?.user
      mixpanel.track("Fetched userinfo via api for appian", { userInfoResponse: userInfoResponse, apiResponse: res ? JSON.stringify(res) : res, code: code });
       return userInfoResponse;
      //  }, (err) => {
        } catch (err: any) {
      mixpanel.track("Error while fetching userinfo with Appian client details", { error: err?.message,code:code })
      this.showAuthLoader = false;
      this.toast.error(err)
      this.spinner.off();
      return null;
    }
  }

  async getBrookfieldUserInfoViaApi(code: string) {
    try{
      const input={
        provider: environment.BROOKFIELD_SSO_PROVIDER,
        code: code,
        redirect_uri:(this.isMobile &&(this.platform.is('ios') || this.platform.is('android')))&& !this.platform.is('mobileweb')?environment.SSO_BROOKFIELD_MOBILE_CALLBACK_URL:environment.SSO_REDIRECT_URL
      }
      mixpanel.track('input params for Brookfield Residential Userinfo', { BrookfieldInput: input })
      let res = await this.fetchLMUserInfo(input).toPromise();
      console.log("Brookfield Residential user response", res);
      const userInfoResponse = res?.data ? res?.data?.user : res?.user
      mixpanel.track("Fetched userinfo via api", { userInfoResponse: userInfoResponse, apiResponse: res ? JSON.stringify(res) : res, code: code });
       return userInfoResponse;
        } catch (err: any) {
      mixpanel.track("Error while fetching userinfo with Brookfield Residential client details", { error: err?.message,code:code })
      this.showAuthLoader = false;
      this.toast.error(err)
      this.spinner.off();
      return null;
    }
  }

  async getADSUserInfoViaApi(code: string) {
    try{
      const input={
        provider: environment.ADS_SSO_PROVIDER,
        code: code,
        redirect_uri:(this.isMobile &&(this.platform.is('ios') || this.platform.is('android')))&& !this.platform.is('mobileweb')?environment.SSO_ADS_MOBILE_CALLBACK_URL:environment.SSO_REDIRECT_URL
      }
      mixpanel.track('input params for ADS Userinfo', { ADSInput: input })
      let res = await this.fetchLMUserInfo(input).toPromise();
      console.log("ADS user response", res);
      const userInfoResponse = res?.data ? res?.data?.user : res?.user
      mixpanel.track("Fetched userinfo via api for ADS", { userInfoResponse: userInfoResponse, apiResponse: res ? JSON.stringify(res) : res, code: code });
       return userInfoResponse;
        } catch (err: any) {
      mixpanel.track("Error while fetching userinfo with ADS client details", { error: err?.message,code:code })
      this.showAuthLoader = false;
      this.toast.error(err)
      this.spinner.off();
      return null;
    }
  }


  async getGuardianUserInfoViaApi(code: string) {
    try{
      const input={
        provider: environment.GUARDIAN_SSO_PROVIDER,
        code: code,
        redirect_uri:(this.isMobile &&(this.platform.is('ios') || this.platform.is('android')))&& !this.platform.is('mobileweb')?environment.SSO_GUARDIAN_MOBILE_CALLBACK_URL:environment.SSO_REDIRECT_URL
      }
      mixpanel.track('input params for Guardian Insurance Userinfo', { GuardianInput: input })
      let res = await this.fetchLMUserInfo(input).toPromise();
      console.log("Guardian Insurance user response", res);
      const userInfoResponse = res?.data ? res?.data?.user : res?.user
      mixpanel.track("Fetched userinfo via api", { userInfoResponse: userInfoResponse, apiResponse: res ? JSON.stringify(res) : res, code: code });
       return userInfoResponse;
        } catch (err: any) {
      mixpanel.track("Error while fetching userinfo with Guardian Insurance client details", { error: err?.message,code:code })
      this.showAuthLoader = false;
      this.toast.error(err)
      this.spinner.off();
      return null;
    }
  }

  async getLMUserInfoViaApi(code: string) {
    try{
    // let userInfoResponse = null;
      const input={
        provider: environment.LMCODE,
        code: code,
        redirect_uri:(this.isMobile &&(this.platform.is('ios') || this.platform.is('android')))&& !this.platform.is('mobileweb')?environment.SSO_LM_MOBILE_CALLBACK_URL:environment.SSO_REDIRECT_URL
      }
    mixpanel.track('input params for LM Userinfo', { LMInput: input })

      // this.fetchLMUserInfo(input).subscribe((res) => {
      let res = await this.fetchLMUserInfo(input).toPromise();
      console.log("LM user response", res);
      const userInfoResponse = res?.data ? res?.data?.user : res?.user
      mixpanel.track("Fetched userinfo via api", { userInfoResponse: userInfoResponse, apiResponse: res ? JSON.stringify(res) : res, code: code });
       return userInfoResponse;
      //  }, (err) => {
        } catch (err: any) {
      mixpanel.track("Error while fetching userinfo with LM client details", { error: err?.message,code:code })
      this.showAuthLoader = false;
      this.toast.error(err)
      this.spinner.off();
      return null;
    }
  }

  async getSSUserInfoViaApi(code: string) {
    try{
      const input={
        provider: environment.SINGLE_STORE_SSO_PROVIDER,
        code: code,
        redirect_uri:(this.isMobile &&(this.platform.is('ios') || this.platform.is('android')))&& !this.platform.is('mobileweb')?environment.SSO_SINGLESTORE_MOBILE_CALLBACK_URL:environment.SSO_REDIRECT_URL
      }
      mixpanel.track('input params for SS Userinfo', { SSInput: input })
      let res = await this.fetchLMUserInfo(input).toPromise();
      console.log("SS user response", res);
      const userInfoResponse = res?.data ? res?.data?.user : (res?.user?res?.user:res)
      mixpanel.track("Fetched userinfo via api SS", { userInfoResponse: userInfoResponse, apiResponse: res ? JSON.stringify(res) : res, code: code });
       return userInfoResponse;
        } catch (err: any) {
      mixpanel.track("Error while fetching userinfo with SS client details", { error: err?.message,code:code })
      this.showAuthLoader = false;
      this.toast.error(err)
      this.spinner.off();
      return null;
    }
  }

  // first time will get call after mobile browser close
 async authenticateSSOTokenForLogin(
    loading: boolean,
    expired: boolean,
    client: any,
    valid: boolean
  ) {
    let code = ''
    if(localStorage.getItem(SSO_PROVIDER) === 'SAP'){
      code = localStorage.getItem(environment.SAP_CODE);
    }else if(localStorage.getItem(SSO_PROVIDER) === 'DENONE'){
      code = localStorage.getItem(environment.DENONE_CODE);
    }else if(localStorage.getItem(SSO_PROVIDER) === 'OKTA'){
      code = localStorage.getItem(environment.OKTA_CODE);
    }else if(localStorage.getItem(SSO_PROVIDER) === 'EXXON'){
      code = localStorage.getItem(environment.EXXON_CODE);
    }else if(localStorage.getItem(SSO_PROVIDER) === 'LULULEMON'){
      code = localStorage.getItem(environment.LULULEMON_CODE);
    }
    else if (localStorage.getItem(SSO_PROVIDER) === 'KOHLER') {
       code = localStorage.getItem(environment.KOHLER_CODE);
    }else if(localStorage.getItem(SSO_PROVIDER) === 'APPIAN'){
    code = localStorage.getItem(environment.APPIAN_CODE);
    }else if (localStorage.getItem(SSO_PROVIDER) === 'LOCKHEED MARTIN'){
      code = localStorage.getItem(environment.LMCODE);
   }
   else if(localStorage.getItem(SSO_PROVIDER) === 'SingleStore'){
    code = localStorage.getItem(environment.SINGLESTORE_CODE);
  }
   else if(localStorage.getItem(SSO_PROVIDER) === 'BROOKFIELD RESIDENTIAL'){
    code = localStorage.getItem(environment.BROOKFIELD_CODE);
  }
   else if(localStorage.getItem(SSO_PROVIDER) === 'ADS'){
    code = localStorage.getItem(environment.ADS_CODE);
  }
   else if(localStorage.getItem(SSO_PROVIDER) === 'GUARDIAN INSURANCE'){
    code = localStorage.getItem(environment.GUARDIAN_CODE);
  }

    if (this.isMobile && code!=='null' && code !=="" && !this.platform.is('mobileweb')) {
      let signInFormSSO: any
      signInFormSSO = await this.checkSSOProviderAndServeAPI(code);
      console.log('signInFormSSO', this.signInFormSSO);
      if (signInFormSSO?.email || signInFormSSO?.sub) {
        mixpanel.track('authenticateSSOtokenForLogin', { 'SSO_provider': localStorage.getItem(SSO_PROVIDER), Code: code })
        this.loginWithSSO(
          signInFormSSO,
          loading,
          expired,
          client,
          valid
        );
      }
      else {
        this.showAuthLoader = false;
        mixpanel.track("user info object is null in else block for LM", { signInFormSSO: signInFormSSO })
      }
    }
  }



  loginWithSSO(
    signInFormSSO: SignInFormSSO,
    loading: boolean,
    expired: boolean,
    client: any,
    valid: boolean
  ) {
    if (!this.isMobile && signInFormSSO&& localStorage.getItem(SSO_PROVIDER)) {
      mixpanel.track("after web app sso verification done externally", { 'showAuth': this.showAuthLoader })
      this.showAuthLoader =true
    }
    if (signInFormSSO) {
      if (!signInFormSSO.pathGroupId) {
        const activePathId = this.appState.get("activePathId");
        if (activePathId && this.appState.get("changePath")) {
          signInFormSSO.pathId = parseInt(activePathId, 10);
          signInFormSSO.changePath = true;
        }
      }
      signInFormSSO.fromMobile = this.cordovaService.onCordova;
    }

   // this.spinner.on();
    this.sessionService.newSessionSSO(signInFormSSO).subscribe(
      (result) => {
       // this.spinner.off();
        console.log('result :', result);
        loading = false;
        this.routingAfterLogin(signInFormSSO, result, expired, client);
      },
      (errorResponse) => {
       // this.spinner.off();
        valid = false;
        loading = false;
        let messages;
        if (
          typeof errorResponse.graphQLErrors !== "undefined" &&
          errorResponse.graphQLErrors.length > 0
        ) {
          messages = errorResponse.graphQLErrors.map((e) => e.message);
        } else {
          messages = [
            "Server or connection issue. Please check your internet connection.",
          ];
        }
        mixpanel.track("Error while trying to login via sso in mutation",{signInFormSSO:signInFormSSO?JSON.stringify(signInFormSSO):signInFormSSO, errorMessage:errorResponse?JSON.stringify(errorResponse):errorResponse})
        this.error = messages.join("<br>");
        this.showAuthLoader = false;
        this.toast.error(this.i18n.t(this.error));
      }
    );
  }

  refreshIfMobile(ref: any) {
    if (this.isMobile) {
      ref.close();
      window.location.reload();
      this.spinner.off()
    }
  }

  getCodeAndStateFromUrl(urlString: any, ref: any) {
    let ssoProvider = localStorage.getItem(SSO_PROVIDER);
    if (urlString.includes("code=") && urlString.includes("state=")) {
      let pamasString = urlString.split("?")[1];
      let codeString = pamasString.split("&")[0];
      let stateString = pamasString.split("&")[1];
      let code = codeString.split("=")[1];
      let state = stateString.split("=")[0];
      mixpanel.track('Fetched code and state from URL',{urlString:urlString, code:code,state:state})
      if (ssoProvider === 'SAP') {
         localStorage.setItem(environment.SAP_CODE, code);
         localStorage.setItem("sap_state", state);
      }
       if (ssoProvider === 'SingleStore') {
         localStorage.setItem(environment.SINGLESTORE_CODE, code);
         localStorage.setItem('singlestore_state', state);
      }
     if (ssoProvider === 'LOCKHEED MARTIN') {
         localStorage.setItem(environment.LMCODE, code);
         localStorage.setItem('lockheedmartin_state', state);
     }
      if (ssoProvider === 'APPIAN') {
         localStorage.setItem(environment.APPIAN_CODE, code);
         localStorage.setItem('appian_state', state);
      }
      if (ssoProvider === 'BROOKFIELD RESIDENTIAL') {
         localStorage.setItem(environment.BROOKFIELD_CODE, code);
         localStorage.setItem('brookfield_state', state);
      }
      if (ssoProvider === 'ADS') {
         localStorage.setItem(environment.ADS_CODE, code);
         localStorage.setItem('ads_state', state);
      }
      if (ssoProvider === 'GUARDIAN INSURANCE') {
         localStorage.setItem(environment.GUARDIAN_CODE, code);
         localStorage.setItem('guardian_state', state);
      }
      this.spinner.on()
      this.refreshIfMobile(ref);
    }
  }


  getAccessCodeFromUrlDenone(urlString: any, ref: any) {
    if (urlString.includes("access_token=")) {
      let splittedValue = urlString?.split('=')
      let unfilteredToken = splittedValue[1]?.split('&')
      let accessToken = Array.isArray(unfilteredToken) ? unfilteredToken[0] : null;
      localStorage.setItem(environment.DENONE_CODE, accessToken);
      this.refreshIfMobile(ref);
    }
  }

  getAccessCodeFromUrlOkta(urlString: any, ref: any) {
    if (urlString.includes("access_token=") ) {
      const splittedValue = urlString.split('=');
      let valueToken = splittedValue[2]?.split('&')
      let token = valueToken[0]?.split('&')
      localStorage.setItem(environment.OKTA_CODE, token);
      localStorage.setItem("okta_state", '123');
      this.refreshIfMobile(ref);
    }
  }

  getAccessCodeFromUrlExxon(urlString: any, ref: any) {
    console.log('getAccessCodeFromUrlExxon urlString :', urlString);
    if (urlString.includes("access_token=")) {
      let splittedValue = urlString?.split('=')
      let unfilteredToken = splittedValue[1]?.split('&')
      let accessToken = Array.isArray(unfilteredToken) ? unfilteredToken[0] : null;
      localStorage.setItem(environment.EXXON_CODE, accessToken);
      this.refreshIfMobile(ref);
    }else{
      this.toast.error(this.i18n.t('access_token not found'))
    }
  }

  getAccessCodeFromUrlLululemon(urlString: any, ref: any) {
    console.log('getAccessCodeFromUrlLululemon urlString :', urlString);
    if (urlString.includes("access_token=")) {
      let splittedValue = urlString?.split('=')
      let unfilteredToken = splittedValue[1]?.split('&')
      let accessToken = Array.isArray(unfilteredToken) ? unfilteredToken[0] : null;
      localStorage.setItem(environment.LULULEMON_CODE, accessToken);
      this.refreshIfMobile(ref);
    }
  }

  getAccessCodeFromUrlKohler(urlString: any, ref: any) {
    console.log('getAccessCodeFromUrlKohler urlString :', urlString);
    mixpanel.track("getAccessCodeFromUrlKohler urlString",{urlString:urlString})
    if (urlString.includes("access_token=")) {
      let splittedValue = urlString?.split('=')
      let unfilteredToken = splittedValue[1]?.split('&')
      let accessToken = Array.isArray(unfilteredToken) ? unfilteredToken[0] : null;
      localStorage.setItem(environment.KOHLER_CODE, accessToken);
      this.refreshIfMobile(ref);
    }
  }
  routingAfterLogin(
    signInFormSSO: SignInFormSSO,
    result: any,
    expired: boolean,
    client: any
  ) {
    if (result.expiredOrRemoved) {
      expired = true;
      client = result.client;
      this.toast.error(this.i18n.t("Client is expired"));
      mixpanel.track("Client is expired", {client: client});
    } else if (result) {
      this.spinner.off();
      localStorage.setItem("lastUserEmail", signInFormSSO["email"]); // LUMBA-982
      let onboaringSurvey = result?.data?.path?.onboardingSurveys?.length > 0 && result?.data.path?.enabledAttributes['onboarding_survey'];
      let isIntroVideo = result?.data.path?.names["isIntroVideo"];
      if (result.showOnboardingSurvey && (onboaringSurvey || isIntroVideo)) {
        this.router.navigate(["/onboarding"], {state: { onboardingSurvey: onboaringSurvey, isIntroVideo: isIntroVideo }});                          
      } else if (result.showCloseout) {
        this.router.navigate(["/closeout"]);
      } else {
        if (result.showOnboardingSurvey && !(result?.data?.path?.onboardingSurveys?.length > 0 || result?.data.path?.names["isIntroVideo"])) {
          this.homeUiService.checkSubpathStatus();
        }
        this.router.navigate(["/main"]);
      }
      this.toast.success(this.i18n.t("You’re in!"));
      mixpanel.track("successfully logged In");
    }else{
      this.toast.error(this.i18n.t('Login failed'));
      mixpanel.track("LogIn failed");
    }
    setTimeout(() => {
      mixpanel.track("Disabled showAuthLoader", { 'AuthScreenstatus':this.showAuthLoader })
      this.showAuthLoader = false;
    }, 400);
    
  }

  async checkSSOProviderAndServeAPI(code: string){
    // this.spinner.on();
      let ssoProvider = localStorage.getItem(SSO_PROVIDER)
      let userInfo = null;
      if(!ssoProvider){ this.toast.error(this.i18n.t('SSO provider not found!')); return false; }

      // check for ssoProvider and call the APIs
      if(localStorage.getItem(SSO_PROVIDER) === 'SAP'){
        this.spinner.off();
        userInfo = await this.getUserTokenSAP(code);
        this.signInFormSSO = {
          email: userInfo.data?.mail,
          ssoUid: userInfo.data?.uid,
          isSso: true,
          changePath: null,
          fromMobile: null,
          pathGroupId: 0,
          pathId: 0,
          ssoProvider: localStorage.getItem(SSO_PROVIDER),
        };
      }else if(localStorage.getItem(SSO_PROVIDER) === 'DENONE'){
        userInfo = await this.getUserInfoDenone(code);
        this.signInFormSSO = {
          email: userInfo.data?.email,
          ssoUid: userInfo.data?.sub,
          isSso: true,
          changePath: null,
          fromMobile: null,
          pathGroupId: 0,
          pathId: 0,
          ssoProvider: localStorage.getItem(SSO_PROVIDER),
        };
      }else if(localStorage.getItem(SSO_PROVIDER) === 'OKTA'){
        userInfo = await this.getUserTokenOkta(code);
        this.signInFormSSO = {
          email: userInfo.data?.email,
          ssoUid: userInfo.data?.sub,
          isSso: true,
          changePath: null,
          fromMobile: null,
          pathGroupId: 0,
          pathId: 0,
          ssoProvider: localStorage.getItem(SSO_PROVIDER),
        };
      }else if(localStorage.getItem(SSO_PROVIDER) === 'EXXON'){
        userInfo = await this.getUserInfoExxon(code);
        console.log('checkSSOProviderAndServeAPI EXXON userInfo :', userInfo);
        this.signInFormSSO = {
          email: userInfo.data?.email,
          ssoUid: userInfo.data?.sub,
          isSso: true,
          changePath: null,
          fromMobile: null,
          pathGroupId: 0,
          pathId: 0,
          ssoProvider: localStorage.getItem(SSO_PROVIDER),
        };
      }else if(localStorage.getItem(SSO_PROVIDER) === 'LULULEMON'){
        console.log('checkSSOProviderAndServeAPI LULULEMON userInfo :', userInfo);
        userInfo = await this.getUserInfoLululemon(code);
        this.signInFormSSO = {
          email: userInfo.data?.email,
          ssoUid: userInfo.data?.sub,
          isSso: true,
          changePath: null,
          fromMobile: null,
          pathGroupId: 0,
          pathId: 0,
          ssoProvider: localStorage.getItem(SSO_PROVIDER),
        };
      }else if(localStorage.getItem(SSO_PROVIDER) === 'KOHLER'){
        console.log('checkSSOProviderAndServeAPI KOHLER userInfo :', userInfo);
        userInfo = await this.getUserInfoKohler(code);
        mixpanel.track("Authenticated userInfo before calling query for Kohler", {userInfo:userInfo?JSON.stringify(userInfo):userInfo, code: code})
        this.signInFormSSO = {
          email: userInfo?.data?.email,
          ssoUid: userInfo?.data?.sub,
          isSso: true,
          changePath: null,
          fromMobile: null,
          pathGroupId: 0,
          pathId: 0,
          ssoProvider: localStorage.getItem(SSO_PROVIDER),
        };
      }else if(localStorage.getItem(SSO_PROVIDER) === 'APPIAN'){
        this.spinner.off();
        this.showAuthLoader =true
        userInfo = await this.getAppianUserInfoViaApi(code);
        if (userInfo) {
          mixpanel.track("Authenticated userInfo before calling query for Appian", { userInfo: userInfo ? JSON.stringify(userInfo) : userInfo, code: code })
          this.signInFormSSO = {
            // email: userInfo?.data ? userInfo?.data?.mail : userInfo?.mail,
            // ssoUid: userInfo?.data ? (userInfo?.data?.uid ? userInfo?.data?.uid : userInfo?.data?.sub) : (userInfo?.uid ? userInfo?.uid : userInfo?.sub),
            email: userInfo?.email,
            ssoUid: userInfo?.sub,
            isSso: true,
            changePath: null,
            fromMobile: null,
            pathGroupId: 0,
            pathId: 0,
            ssoProvider: localStorage.getItem(SSO_PROVIDER),
          };
        }
        else {
           this.showAuthLoader =false
          mixpanel.track("user info object is null in else block",{userInfo:userInfo})
        }
      }else if(localStorage.getItem(SSO_PROVIDER) === 'BROOKFIELD RESIDENTIAL') {
          this.spinner.off();
          this.showAuthLoader = true
          userInfo = await this.getBrookfieldUserInfoViaApi(code);
          if (userInfo) {
            mixpanel.track("Authenticated userInfo before calling query for Brookfield Residential", { userInfo: userInfo ? JSON.stringify(userInfo) : userInfo, code: code })
            this.signInFormSSO = {
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER),
            };
          }
        else {
           this.showAuthLoader =false
          mixpanel.track("user info object is null in else block for brookfield",{userInfo:userInfo})
        }
      } else if(localStorage.getItem(SSO_PROVIDER) === 'ADS') {
          this.spinner.off();
          this.showAuthLoader = true
          userInfo = await this.getADSUserInfoViaApi(code);
          if (userInfo) {
            mixpanel.track("Authenticated userInfo before calling query for ADS", { userInfo: userInfo ? JSON.stringify(userInfo) : userInfo, code: code })
            this.signInFormSSO = {
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER),
            };
          }
        else {
           this.showAuthLoader =false
          mixpanel.track("user info object is null in else block for ADS",{userInfo:userInfo})
        }
      } else if (localStorage.getItem(SSO_PROVIDER) === 'GUARDIAN INSURANCE') {
          this.spinner.off();
          this.showAuthLoader = true
          userInfo = await this.getGuardianUserInfoViaApi(code);
          if (userInfo) {
            mixpanel.track("Authenticated userInfo before calling query for Guardian Insurance", { userInfo: userInfo ? JSON.stringify(userInfo) : userInfo, code: code })
            this.signInFormSSO = {
              email: userInfo?.email,
              ssoUid: userInfo?.sub,
              isSso: true,
              changePath: null,
              fromMobile: null,
              pathGroupId: 0,
              pathId: 0,
              ssoProvider: localStorage.getItem(SSO_PROVIDER),
            };
          }
        else {
           this.showAuthLoader =false
          mixpanel.track("user info object is null in else block",{userInfo:userInfo})
        }
      } else if (localStorage.getItem(SSO_PROVIDER) === 'LOCKHEED MARTIN')  {
        this.spinner.off();
        this.showAuthLoader =true
        userInfo = await this.getLMUserInfoViaApi(code);
        if (userInfo) {
          mixpanel.track("Authenticated userInfo before calling query for LM", { userInfo: userInfo ? JSON.stringify(userInfo) : userInfo, code: code })
          this.signInFormSSO = {
            // email: userInfo?.data ? userInfo?.data?.mail : userInfo?.mail,
            // ssoUid: userInfo?.data ? (userInfo?.data?.uid ? userInfo?.data?.uid : userInfo?.data?.sub) : (userInfo?.uid ? userInfo?.uid : userInfo?.sub),
            email: userInfo?.email,
            ssoUid: userInfo?.sub,
            isSso: true,
            changePath: null,
            fromMobile: null,
            pathGroupId: 0,
            pathId: 0,
            ssoProvider: localStorage.getItem(SSO_PROVIDER),
          };
        }
        else {
           this.showAuthLoader =false
          mixpanel.track("user info object is null in else block",{userInfo:userInfo})
        }
      }else if(localStorage.getItem(SSO_PROVIDER) === 'SingleStore'){
        this.spinner.off();
        this.showAuthLoader =true
        userInfo = await this.getSSUserInfoViaApi(code);
        if (userInfo?.email || userInfo?.sub) {
          mixpanel.track("Authenticated userInfo before calling query for SS", { userInfo: userInfo ? JSON.stringify(userInfo) : userInfo, code: code })
          this.signInFormSSO = {
            email: userInfo?.email,
            ssoUid: userInfo?.sub,
            isSso: true,
            changePath: null,
            fromMobile: null,
            pathGroupId: 0,
            pathId: 0,
            ssoProvider: localStorage.getItem(SSO_PROVIDER),
          };
        }
        else {
          this.showAuthLoader = false
          this.toast.error(this.i18n.t('Failed to fetch user information due to server error'))
          mixpanel.track("user info object is null/error in else block", { userInfo: userInfo })
        }
      }
      localStorage.setItem(environment.SAP_CODE, null);
      localStorage.setItem(environment.DENONE_CODE, null);
      localStorage.setItem(environment.OKTA_CODE, null);
      localStorage.setItem(environment.EXXON_CODE, null);
      localStorage.setItem(environment.LULULEMON_CODE, null);
      localStorage.setItem(environment.KOHLER_CODE, null);
      localStorage.setItem(environment.APPIAN_CODE, null);
      localStorage.setItem(environment.LMCODE, null);
      localStorage.setItem(environment.BROOKFIELD_CODE, null);
      localStorage.setItem(environment.ADS_CODE, null);
      localStorage.setItem(environment.GUARDIAN_CODE, null);
      localStorage.setItem(environment.SINGLESTORE_CODE, null);
      console.log('this.signInFormSSO;', this.signInFormSSO);

      return this.signInFormSSO;
  }

  validateMail(userEmail: string){
    // below regex validate email only
    // const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const regex = /^(?:[a-zA-Z0-9._%+\'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|[a-zA-Z0-9]+)$/;
    const match = userEmail.match(regex);
    return match
  }

  removeWhiteSpaces(inputText){
    // let trimmedText = inputText.replace(/\s+/g, ''); // Removes all white spaces
    let trimmedText = inputText.trim();
    return trimmedText
  }

  validateLoginId(input: string): boolean {
    const digitRegex = /^\d+$/;
    return digitRegex.test(input);
  }

}
